import React, { useEffect } from 'react';
import { Modal, Result, Icon } from 'antd';
import { ModalBody, ModalContainer, Container, VariableList } from './styles';
import { withTranslation } from 'react-i18next';
import { TRANSACTIONS_VARIABLES_DETAILS_MODAL, GENERATE_PDF_VARIABLES_DETAILS_MODAL, MAILROOM_VARIABLES_DETAILS_MODAL } from './translationValues';

const NAMESPACES = ['TRANSACTIONS_VARIABLES_DETAILS_MODAL', 'GENERATE_PDF_VARIABLES_DETAILS_MODAL', 'MAILROOM_VARIABLES_DETAILS_MODAL'];
const GENERATE_PDF_VARIABLES_DETAILS_MODAL_NAMESPACE = 'GENERATE_PDF_VARIABLES_DETAILS_MODAL';
const MAILROOM_VARIABLES_DETAILS_MODAL_NAMESPACE = 'MAILROOM_VARIABLES_DETAILS_MODAL'

const VariableDetailsModal = props => {
  const {
    visible,
    onCancel,
    variables,
    isGeneratingPDF,
    isViewTags,
    tagsData,
    isMissedVarList,
    isPublishedMessages,
    showMaxLength = true,
    t,
  } = props;

  useEffect(() => {
    if (variables && variables.length === 0 && !isGeneratingPDF) {
      setTimeout(() => {
        onCancel();
      }, 2000);
    }
  }, [isGeneratingPDF]);

  return (
    <Container onKeyDown={e => e.stopPropagation()}>
      <Modal
        title={
          isMissedVarList
            ? t(TRANSACTIONS_VARIABLES_DETAILS_MODAL.MISSED_VARIABLE_LIST_MODAL_TITLE.key, TRANSACTIONS_VARIABLES_DETAILS_MODAL.MISSED_VARIABLE_LIST_MODAL_TITLE.value)
            : isViewTags
            ? t(`${MAILROOM_VARIABLES_DETAILS_MODAL_NAMESPACE}:${MAILROOM_VARIABLES_DETAILS_MODAL.TAG_DETAILS_MODAL_TITLE.key}`, MAILROOM_VARIABLES_DETAILS_MODAL.TAG_DETAILS_MODAL_TITLE.value)
            : variables?.length === 0
            ? t(`${GENERATE_PDF_VARIABLES_DETAILS_MODAL_NAMESPACE}:${GENERATE_PDF_VARIABLES_DETAILS_MODAL.GENERATE_PDF_MODAL_TITLE.key}`, GENERATE_PDF_VARIABLES_DETAILS_MODAL.GENERATE_PDF_MODAL_TITLE.value)
            : t(TRANSACTIONS_VARIABLES_DETAILS_MODAL.TEMPLATE_VARIABLE_DETAILS_MODAL_TITLE.key, TRANSACTIONS_VARIABLES_DETAILS_MODAL.TEMPLATE_VARIABLE_DETAILS_MODAL_TITLE.value)
        }
        maskClosable={false}
        centered
        visible={visible}
        width="700px"
        onCancel={onCancel}
        footer={false}
        className="warning-modal"
      >
        <ModalBody>
          <ModalContainer width={'500px'}>
            {isViewTags ? (
              <VariableList>
                <div className="details title">
                  <p className="name">{t(`${MAILROOM_VARIABLES_DETAILS_MODAL_NAMESPACE}:${MAILROOM_VARIABLES_DETAILS_MODAL.TAG_ID_COLUMN_TITLE.key}`, MAILROOM_VARIABLES_DETAILS_MODAL.TAG_ID_COLUMN_TITLE.value)}</p>
                  <p className="name">{t(`${MAILROOM_VARIABLES_DETAILS_MODAL_NAMESPACE}:${MAILROOM_VARIABLES_DETAILS_MODAL.TAG_NAME_VARIABLE_TITLE.key}`, MAILROOM_VARIABLES_DETAILS_MODAL.TAG_NAME_VARIABLE_TITLE.value)}</p>
                </div>
                <div className="varScrollSec">
                  {tagsData &&
                    tagsData.map(eachTag => (
                      <div className="details">
                        <p className="name">{eachTag.tagId}</p>
                        <p className="name">{eachTag.tagName}</p>
                      </div>
                    ))}
                </div>
              </VariableList>
            ) : variables && variables.length === 0 ? (
              isGeneratingPDF ? (
                <Result icon={<Icon type={'loading'} />} title={t(`${GENERATE_PDF_VARIABLES_DETAILS_MODAL_NAMESPACE}:${GENERATE_PDF_VARIABLES_DETAILS_MODAL.GENERATING_PDF_MESSAGE.key}`, GENERATE_PDF_VARIABLES_DETAILS_MODAL.GENERATING_PDF_MESSAGE.value)} />
              ) : (
                <Result status={'success'} title={t(`${GENERATE_PDF_VARIABLES_DETAILS_MODAL_NAMESPACE}:${GENERATE_PDF_VARIABLES_DETAILS_MODAL.PDF_GENERATED_SUCCESSFULLY_SUCCESS_MESSAGE.key}`, GENERATE_PDF_VARIABLES_DETAILS_MODAL.PDF_GENERATED_SUCCESSFULLY_SUCCESS_MESSAGE.value)} />
              )
            ) : (
              <VariableList>
                <div className="details title">
                  <p className="name">{t(TRANSACTIONS_VARIABLES_DETAILS_MODAL.NAME_VARIABLE_COLUMN_TITLE.key, TRANSACTIONS_VARIABLES_DETAILS_MODAL.NAME_VARIABLE_COLUMN_TITLE.value)}</p>
                  <p className="type">{t(TRANSACTIONS_VARIABLES_DETAILS_MODAL.TYPE_VARIABLE_COLUMN_TITLE.key, TRANSACTIONS_VARIABLES_DETAILS_MODAL.TYPE_VARIABLE_COLUMN_TITLE.value)}</p>
                  {showMaxLength && <p className="maxLength">{t(TRANSACTIONS_VARIABLES_DETAILS_MODAL.MAX_LENGTH_VARIABLE_COLUMN_TITLE.key, TRANSACTIONS_VARIABLES_DETAILS_MODAL.MAX_LENGTH_VARIABLE_COLUMN_TITLE.value)}</p>}
                </div>
                <div className="varScrollSec">
                  {variables &&
                    variables.map(eachVar => (
                      <div className="details">
                        <p className="name">{eachVar.name}</p>
                        <p className="type">{eachVar.type}</p>
                        {showMaxLength && <p className="maxLength">{eachVar.maxLength}</p>}
                      </div>
                    ))}
                </div>
                <p className="note">
                  {t(TRANSACTIONS_VARIABLES_DETAILS_MODAL.NOTE_TITLE.key, TRANSACTIONS_VARIABLES_DETAILS_MODAL.NOTE_TITLE.value)} {isPublishedMessages && '1)'} {t(TRANSACTIONS_VARIABLES_DETAILS_MODAL.DATE_FORMAT_NOTE.key, TRANSACTIONS_VARIABLES_DETAILS_MODAL.DATE_FORMAT_NOTE.value)}
                  <br />
                  {isPublishedMessages && (
                    <span>
                      &nbsp;&nbsp;&nbsp;2) {t(TRANSACTIONS_VARIABLES_DETAILS_MODAL.MOBILE_FORMAT_NOTE.key, TRANSACTIONS_VARIABLES_DETAILS_MODAL.MOBILE_FORMAT_NOTE.value)}
                    </span>
                  )}
                </p>
              </VariableList>
            )}
          </ModalContainer>
        </ModalBody>
      </Modal>
    </Container>
  );
};
export default withTranslation(NAMESPACES)(VariableDetailsModal);
